import * as React from "react";
import {AxiosResponse} from "axios";
import {HttpErrorModel} from "../../../../../common/models/httpError";
import {Popup} from "../../../../../common/components/shared/popup/popup";
import i18n from "../../../../../i18n/i18n";
import {RelationType} from "../../../../models/relation";
import {OrderUtils} from "../../../../../helpers/orderUtils";
import TextInput from "../../../../../common/components/shared/textInput/textInput";
import {ValidatedValue} from "../../../../../helpers/validatedValue";
import "./assignWagonsNumberPopup.scss";
import {Api} from "../../../../../helpers/api";
import {HttpError} from "../../../../../common/components/shared/httpError/httpError";
import {OrderDetailModel} from "../../../../models/order";

interface AssignWagonsNumberPopupProps {
    displayPopup: boolean;
    relationType: RelationType | "";
    confirm: () => void;
    closePopup: () => void;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
    isWaiting?: boolean;
    wagonRegNo: ValidatedValue<string>;
    supplierWagonRegNo: ValidatedValue<string>;
    recipientWagonRegNo: ValidatedValue<string>;
    orderData: OrderDetailModel;
}

export default function AssignWagonsNumberPopup(props: AssignWagonsNumberPopupProps) {
    return (
        <Popup
            open={props.displayPopup}
            className="assign-wagons-number-popup"
            header={i18n.t("transportation.order.details.assignWagonsNumberPopup.header")}
            secondHeader={renderHeader()}
            content={renderContent()}
            actionText={i18n.t("save")}
            action={props.confirm}
            cancel={props.closePopup}
            testId="assign-wagons-number-popup"
            httpError={renderErrors()}
            isWaiting={props.isWaiting}
        />
    );

    function renderHeader() {
        return "";
    }

    function renderContent() {
        return (
            <>
                <p>{i18n.t("transportation.order.details.assignWagonsNumberPopup.contentPart1")}</p>
                {renderWagonRegNoInput()}
                {renderSupplierWagonRegNoInput()}
                {renderRecipientWagonRegNoInput()}
                <p>{i18n.t("transportation.order.details.assignWagonsNumberPopup.contentPart2")}</p>
            </>
        );
    }

    function renderWagonRegNoInput() {
        return (
            OrderUtils.displayWagonRegNo(props.relationType) && (
                <TextInput
                    className="wagon-input"
                    label={i18n.t("transportation.order.details.cargo.properties.wagonRegNo")}
                    validatedValue={props.wagonRegNo}
                    testId="wagon-reg-no-input"
                    offAutocomplete
                />
            )
        );
    }

    function renderSupplierWagonRegNoInput() {
        return (
            (OrderUtils.displaySupplierWagonRegNo(props.relationType) && !props.orderData.supplierWagonRegNo) && (
                <TextInput
                    className="wagon-input"
                    label={i18n.t("transportation.order.details.cargo.properties.supplierWagonRegNo")}
                    validatedValue={props.supplierWagonRegNo}
                    testId="supplier-wagon-reg-no-input"
                    offAutocomplete
                />
            )
        );
    }

    function renderRecipientWagonRegNoInput() {
        return (
            (OrderUtils.displayRecipientWagonRegNo(props.relationType) && !props.orderData.recipientWagonRegNo) && (
                <TextInput
                    className="wagon-input"
                    label={i18n.t("transportation.order.details.cargo.properties.recipientWagonRegNo")}
                    validatedValue={props.recipientWagonRegNo}
                    testId="recipient-wagon-reg-no-input"
                    offAutocomplete
                />
            )
        );
    }

    function renderErrors() {
        return (
            <>
                {!Api.isSuccess(props.response) && (
                    <HttpError
                        response={props.response}
                        cause={i18n.t("transportation.order.details.assignWagonsNumberPopup.assignWagonsNumberErrorSuffix")}
                    />
                )}
            </>
        );
    }
}
